"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no class with a given id exists
 * @param {string} classId
 */
class ClassDoesNotExistError extends client_library_1.ExtendableError {
    constructor(classId) {
        super(`class: classId ${classId} does not exist`);
        this.classId = classId;
    }
}
exports.default = ClassDoesNotExistError;
//# sourceMappingURL=ClassDoesNotExistError.js.map